<template>
  <div class="flex flex-col w-full h-full justify-start items-start bg-white overflow-y-auto">
    <div class="w-full h-12 p-4 shadow-md ">
      <span class="text-large text-black text-bold font-600 mr-3">Layout2</span>
    </div>

    <div class="flex flex-col px-4 gap-4 mt-4 w-full items-center"></div>
    <div class="flex flex-col w-full h-full p-0 justify-start items-center">
      <div class="w-[960px] mt-4">
        <el-carousel :interval="4000" type="card" class="w-full h-full">
          <el-carousel-item v-for="item in carouselData" :key="item.title">
            <img :src="item.image" alt="Carousel Image" class="w-full h-full object-cover" />
            <h3 text="2xl" justify="center">{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>

  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Layout2',

  setup() {
    const carouselData = [
      {
        image: '/assets/1180×860_1.png',
        title: 'Image 1',
        description: 'This is the first image'
      },
      {
        image: '/assets/1180×860_2.png',
        title: 'Image 2',
        description: 'This is the second image'
      },
      {
        image: '/assets/1180×860_3.png',
        title: 'Image 3',
        description: 'This is the third image'
      }
    ]
    return {
      carouselData
    }
  }
});


</script>
<style scoped>
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>